export default __webpack_public_path__ + "static/media/empty-state-user-not-found.90c6b2a5.svg";